import RoseAnimation from "@/components/gift-animations/RoseAnimation";
import FireAnimation from "@/components/gift-animations/FireAnimation";
import DiamondAnimation from "@/components/gift-animations/DiamondAnimation";
import CrownAnimation from "@/components/gift-animations/CrownAnimation";
import RocketAnimation from "@/components/gift-animations/RocketAnimation";
import PandaAnimation from "@/components/gift-animations/PandaAnimation";
import BottleAnimation from "@/components/gift-animations/BottleAnimation";
import CakeAnimation from "@/components/gift-animations/CakeAnimation";
import KissAnimation from "@/components/gift-animations/KissAnimation";
import CastleAnimation from "@/components/gift-animations/CastleAnimation";

/**
 * Map of gift_key -> animation component. When a gift key is in this map,
 * LiveGiftOverlay and other consumers render the full SVG+CSS animation
 * for it. Everything else falls back to the emoji burst that already
 * ships in LiveGiftOverlay (which is faster & lighter for the long tail
 * of Live-Menu / Buzz / DM gifts that already have their own effects).
 *
 * We animate all 10 of the classic-tier tips (10 of the 12 classics — the
 * remaining lambo and yacht still ride the emoji-burst variant to keep the
 * total animation cost bounded). Live-menu, buzz and DM gifts keep their
 * existing category-specific burst + haptic + audio effects so mobile FPS
 * stays healthy when tips cascade.
 */
const ANIMATIONS = {
  rose: RoseAnimation,
  fire: FireAnimation,
  diamond: DiamondAnimation,
  crown: CrownAnimation,
  rocket: RocketAnimation,
  panda: PandaAnimation,
  bottle: BottleAnimation,
  cake: CakeAnimation,
  kiss: KissAnimation,
  castle: CastleAnimation,
};

export function isAnimatedGift(giftKey) {
  return Boolean(giftKey && ANIMATIONS[giftKey]);
}

/**
 * <GiftAnimation giftKey="rose" size={140} /> → renders the animation.
 * Returns null for unknown gift keys so callers can render an emoji fallback.
 */
export default function GiftAnimation({ giftKey, size = 140 }) {
  const Component = ANIMATIONS[giftKey];
  if (!Component) return null;
  return <Component size={size} />;
}
